import  { TheSFTAddress } from "./TheSFT";
export const FantomtestTheSFTAddress = TheSFTAddress
